import {request} from '../utils/request'

const answerExam = {
    // 获取试卷列表
    getAnswerStyle:function(data) {
        return request({
            method: "POST",
            url: "/api/answerExam/answerExamService/getAnswerStyle",
            data
        });
    },
    saveAnswerExam:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/saveAnswerExam",
        data
      });
    },
    //获取调查问卷list
    getAnswerExamList:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/getAnswerExamList",
        data
      });
    },
    //获取调查问卷用户信息
    getAnswerExamUserList:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/getAnswerExamUserList",
        data
      });
    },
    //获取调查问卷题目
    getAnswerExamPaperTest:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/getAnswerExamPaperTest",
        data
      });
    },
    //获取调查问卷题目
    deleteAnswerExam:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/deleteAnswerExam",
        data
      });
    },
    //获取调查问卷题目
    updateAnswerExamIsShow:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/updateAnswerExamIsShow",
        data
      });
    },
    //判断是否有用户编辑
    checkAnswerExamIsEdit:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/checkAnswerExamIsEdit",
        data
      });
    },
    //获取调查问卷题目
    getAnswerExamUserPaperTest:function (data) {
      return request({
        method: "POST",
        url: "/api/answerExam/answerExamService/getAnswerExamUserPaperTest",
        data
      });
    },
}

export default answerExam;
